module.exports = __webpack_public_path__ + "img/sweden-external-causes-female.de685834.png";